// extracted by mini-css-extract-plugin
export default {"web_profile_card":"WebProfileCard_web_profile_card__UCY--","card-img":"WebProfileCard_card-img__5XdXY"};